var app = angular.module("leonardo");

var ReportsPropertyAmenitiesListFilters = function(
  $scope,
  $controller,
  $timeout,
  $q,
  ngDialog,
  $rootScope,
  ReportService,
  FieldSubgroupService,
  FilterService,
  FieldSubgroupServiceDetailsView
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersPropertyAmenities;

  $scope.group_options.push({ id: 'managed_by', name: 'Managed By' });

  $scope.filters_options = [];

  $scope.fieldsReport = [];
  $scope.workingDays = [];
  $scope.withOutAttributes = [];

  $scope.sector = $scope.authDataService.isNotStaff() ? $scope.authDataService.authData.account.sector : null;

  $scope.getFieldsReport = function () {
    var fields = [{ id:'groups', name: 'Property Group',fields: ''}, {id: 'pms_external_id', name:'PMS Property ID',fields: ''}]
    angular.forEach($scope.subGroups, function (subgroup) {
      fields.push({ id: subgroup.key, name: subgroup.name, fields: subgroup.fields });
    });
    $scope.fieldsReport = fields;

    //Push Fields in FieldReport only detail view
    let childArray = []
    if(FilterService.filters.detailed){
      angular.forEach($scope.fieldsReport, function(group) {
        angular.forEach(group.fields, function(field) {
         if(FilterService.filters && FilterService.filters.fields_active && FilterService.filters.fields_active.split(',').includes(field.key)){
            childArray.push({
              id: field.key,
              name: field.name,
              groupId: group.id
            })
         }
        });
      });
     $scope.fieldsReport =  $scope.fieldsReport.concat(childArray);
    }
  };

  $scope.getWithoutAttributes = function () {
    var fields = [{ id:'', name: 'All Properties'}, {id: false, name:'With Attributes'}, {id: true, name:'Without Attributes'}]
    $scope.withOutAttributes = fields;
  };

  $scope.prepareFields = function () {
    $scope.workingDays = [];
    $scope.withOutAttributes = [];
    angular.forEach($scope.subGroups, function (subgroup) {
      if (subgroup.group) {
        if(subgroup.group.id === 1  && subgroup.key === 'working_days'){
          angular.forEach(subgroup.fields, function(field) {
            if (field.key !== 'working_days_all') {
              $scope.workingDays.push({id:field.key, name:field.name});
            }
          });
        }
      }
    });
    $scope.getFieldsReport();
    $scope.getWithoutAttributes();
  };

  $scope.initOptions = function () {
    var defer = $q.defer();
  
    // For My Report Section Details View Open
    if (FilterService.filters && FilterService.filters.detailed) {
      loadFilters(FieldSubgroupServiceDetailsView, defer);
    } else {
      loadFilters(FieldSubgroupService, defer);
    }
  
    return defer.promise;
  };
  
  function loadFilters(service, defer) {
    var internalDefer = $q.defer();
    $scope.allSubGroups = [];
    service.getAll({ summary: true, sector: $scope.sector }).then(function (results) {
      $scope.subGroups = results;
      if (FilterService.filters && FilterService.filters.detailed) {
        var fields =[];
        angular.forEach(results, function (subgroup) {
          fields.push({ id: subgroup.key, name: subgroup.name, fields: subgroup.fields });
        });
        $scope.options =  fields;
        angular.forEach($scope.options, function (subgroup) {
          if (subgroup.group) {
            if ((subgroup.group.id != 1) || !_.contains(['property_address', 'working_days'], subgroup.key)) {
              $scope.allSubGroups.push(subgroup);
            }
          } else {
            $scope.allSubGroups.push(subgroup);
          }
        });
  
        $scope.allSubGroups = $scope.allSubGroups.filter(item => item.id !== 'groups' && item.id !== 'pms_external_id' && !item.hasOwnProperty('groupId'));
        FilterService.allSubFieldsGroup = $scope.allSubGroups;
      }
      $scope.prepareFields();
      $timeout(function () {
        $scope.filters_options = $scope.filters_base.concat([
          {
            id: 'name',
            name: 'Property Name',
            label: 'Property Name',
            inline: false,
            type: 'text',
            placeholder: 'Property Name',
            condition: true,
            conflicts: [],
            onSubmit: $scope.display
          },
          {
            id: 'without_amenities',
            name: 'Attribute Status',
            label: 'Attribute Status',
            inline: false,
            type: 'options',
            condition: true,
            conflicts: [],
            options: $scope.withOutAttributes,
          },
          {
            id: 'working_days',
            name: 'Working Days',
            label: 'Working Days',
            labelAll: 'Select All',
            inline: false,
            type: 'options',
            multiple: true,
            clean: false,
            placeholder: 'Select Days',
            condition: true,
            options: $scope.workingDays,
            conflicts: []
          },
          {
            id: 'lookup_filters',
            name: 'Property Rules',
            label: 'Property Rules',
            inline: false,
            type: 'rules_property',
            placeholder: 'Select Rules',
            condition: true,
            options: $scope.subGroups,
            conflicts: []
          },
          {
            id: 'levels',
            name: 'Property Address',
            label: 'Property Address',
            inline: false,
            type: 'levels',
            condition: true,
            conflicts: []
          },
          {
            id: 'fields_active',
            name: 'Fields To Show',
            label: 'Fields To Show',
            inline: false,
            type: 'columns',
            placeholder: 'Select Fields',
            condition: true,
            options: $scope.fieldsReport,
            conflicts: []
          },
          {
            id: 'extra_fields',
            name: 'Database IDs To Show',
            label: 'Database IDs To Show',
            inline: false,
            type: 'columns',
            placeholder: 'Select Fields',
            condition: true,
            options: ReportService.propertyIdFields,
            conflicts: []
          }
        ]);
  
        if ($scope.filters_name !== 'filters_report') {
          var filters = $scope.filterService.hasFilter($scope.filters_name) ? $scope.filterService.getFilter($scope.filters_name) : [];
  
          if (!angular.isArray(filters)) {
            filters = filters.split(',');
          }
          var working_days = [];
  
          angular.forEach($scope.filterService.filters, function (value, key) {
            if (!_.contains(filters, key) && $scope.isValid(key)) {
              filters.push(key);
            }
            else if (key === 'working_days_all') {
              working_days = $scope.workingDays.map((item) => item.id);
            }
            else if (key.includes('working_days_')) {
              working_days.push(key);
            }
          });
  
          if (working_days.length > 0) {
            $scope.filterService.setFilter('working_days', working_days.join(','), true);
            if (!_.contains(filters, 'working_days')) {
              filters.push('working_days');
            }
          }
  
          $scope.filterService.setFilter('group_by', 'account');
          $scope.filterService.setFilter($scope.filters_name, filters, true);
        }
        $rootScope.$broadcast('filters-report:initialized');
        internalDefer.resolve();
      }, 10);
    });
  
    internalDefer.promise.then(function () {
      defer.resolve();
    });
  }
  

  $scope.initOptions();

  $scope.getIndex = function(id) {
    var index = -1;
    angular.forEach($scope.fieldsReport, function(value, key){
      if (value.id === id) {
        index = key;
      }
    });
    angular.forEach($scope.withOutAttributes, function(value, key){
      if (value.id === id) {
        index = key;
      }
    });
    return index;
  };

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', ReportService.TYPE_PROPERTY_AMENITIES);
  }, 100);

};

app.controller('ReportsPropertyAmenitiesListFilters', [
  '$scope',
  '$controller',
  '$timeout',
  '$q',
  'ngDialog',
  '$rootScope',
  'ReportService',
  'FieldSubgroupService',
  'FilterService',
  'FieldSubgroupServiceDetailsView',
  ReportsPropertyAmenitiesListFilters
]);
